import axios from "axios";
import { API_URL } from "../constants/config";

const SALES_BASE = `${API_URL}/api/sales`;

const buildParams = (params = {}) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      if (value.length > 0) usp.set(key, value.join(","));
      return;
    }
    usp.set(key, value);
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
};

export const fetchSalesList = async (params = {}) => {
  const response = await axios.get(`${SALES_BASE}${buildParams(params)}`, {
    timeout: 30000,
  });
  return response.data;
};

export const fetchSale = async (saleId) => {
  const response = await axios.get(`${SALES_BASE}/${saleId}`);
  return response.data;
};

export const createSale = async (newSale) => {
  const response = await axios.post(SALES_BASE, newSale);
  return response.data;
};

export const updateSale = async (saleId, updatedSale) => {
  const response = await axios.put(`${SALES_BASE}/${saleId}`, updatedSale);
  return response.data;
};

export const deleteSale = async (saleId) => {
  const response = await axios.delete(`${SALES_BASE}/${saleId}`);
  return response.data;
};

export const fetchSalesStats = async () => {
  const response = await axios.get(`${SALES_BASE}/stats`);
  return response.data;
};

export const fetchSalesFinancialStats = async () => {
  const response = await axios.get(`${SALES_BASE}/financial-stats`);
  return response.data;
};

export const fetchUpcomingSales = async (limit = 5) => {
  const response = await axios.get(`${SALES_BASE}/upcoming?limit=${limit}`);
  return response.data;
};

export const uploadSalesFile = async (files) => {
  const response = await axios.post(`${SALES_BASE}/upload`, files);
  return response.data;
};

export const fetchSaleFile = async (id) => {
  const response = await axios.get(`${SALES_BASE}/files/${id}`, {
    responseType: "blob",
  });
  return response;
};

export const deleteSaleFile = async (file) => {
  const response = await axios.delete(`${SALES_BASE}/files/${file}`);
  return response.data;
};
